import React, { useMemo, useState } from 'react';
import { QRCodeCanvas } from 'qrcode.react';
import './InvitacionRender.css';

export const INVITACION_DEFAULT_LAYOUT = {
  qrTop: '50.5%',
  qrLeft: '51.5%',
  qrSize: 130,
  nameBottomPx: 126.3,
  nameBottomPct: null,
  nameLeft: '51.5%',
  nameFontSize: 12,
  nameColor: '#000000',
  nameShadow: true,
};

export const numberFromPercent = (value, fallback = 50) => {
  if (typeof value === 'number') return value;
  const parsed = parseFloat(String(value ?? '').replace('%', ''));
  return Number.isFinite(parsed) ? parsed : fallback;
};

export const clamp = (value, min, max) => Math.min(Math.max(value, min), max);

export const getNameBottomPct = (layout, altoLogico = 533, fallbackPx = 126.3) => {
  if (layout?.nameBottomPct !== undefined && layout?.nameBottomPct !== null) {
    return clamp(numberFromPercent(layout.nameBottomPct, 23.7), 0, 100);
  }
  const px = Number(layout?.nameBottomPx ?? fallbackPx);
  const h = Number(altoLogico || 533);
  return clamp((px / h) * 100, 0, 100);
};

export default function InvitacionRender({
  fondo,
  codigo,
  nombre = 'NOMBRE DE PRUEBA',
  layout,
  width = 300,
  className = '',
  showGuides = false,
  onImageLoad,
  onNamePointerDown,
}) {
  const L = useMemo(() => ({ ...INVITACION_DEFAULT_LAYOUT, ...(layout || {}) }), [layout]);
  const [aspectRatio, setAspectRatio] = useState('9 / 16');
  const [altoLogico, setAltoLogico] = useState(533);

  const qrTopPct = numberFromPercent(L.qrTop, 50.5);
  const qrLeftPct = numberFromPercent(L.qrLeft, 51.5);
  const nameLeftPct = numberFromPercent(L.nameLeft, 51.5);
  const nameBottomPct = getNameBottomPct(L, altoLogico);
  const codigoQR = codigo ? `https://www.rao-ing.shop/invitacion/${codigo}` : 'https://www.rao-ing.shop/invitacion/PREVIEW123';

  const handleLoad = (event) => {
    const img = event.currentTarget;
    if (img?.naturalWidth && img?.naturalHeight) {
      setAspectRatio(`${img.naturalWidth} / ${img.naturalHeight}`);
      setAltoLogico((300 * img.naturalHeight) / img.naturalWidth);
    }
    onImageLoad?.(event);
  };

  return (
    <div
      className={`palma-invitacion-render ${showGuides ? 'palma-invitacion-render--guides' : ''} ${className}`.trim()}
      style={{ width, aspectRatio }}
    >
      <img
        className="palma-invitacion-bg"
        src={fondo || '/arte-semanal.jpg'}
        alt="Invitación"
        onLoad={handleLoad}
        crossOrigin="anonymous"
        draggable="false"
      />

      <div
        className="palma-invitacion-qr"
        style={{ top: `${qrTopPct}%`, left: `${qrLeftPct}%` }}
      >
        <QRCodeCanvas value={codigoQR} size={Number(L.qrSize || 130)} style={{ display: 'block' }} />
      </div>

      <div
        className={'palma-invitacion-name'+(onNamePointerDown?' cal-name-target':'')}
        role={onNamePointerDown?'button':undefined}
        aria-label={onNamePointerDown?'Mover nombre':undefined}
        tabIndex={onNamePointerDown?0:undefined}
        onPointerDown={onNamePointerDown}
        style={{
          bottom: `${nameBottomPct}%`,
          left: `${nameLeftPct}%`,
          color: L.nameColor || '#000000',
          fontSize: `${Number(L.nameFontSize || 12)}px`,
          textShadow: L.nameShadow === false ? 'none' : '2px 2px 4px rgba(0,0,0,0.7)',
        }}
      >
        {String(nombre || '').toUpperCase()}
      </div>
    </div>
  );
}
